import { useCallback } from 'react';
import { useI18n } from '../i18n';
import { en } from '../i18n/translations/en';
import { fr } from '../i18n/translations/fr';
import { pt } from '../i18n/translations/pt';

const translations = {
  en,
  fr,
  pt
};

export function useTranslation() {
  const { language } = useI18n();

  const t = useCallback((path: string) => {
    const keys = path.split('.');
    let value: any = translations[language];

    for (const key of keys) {
      if (value === undefined) return path;
      value = value[key];
    }

    return value || path;
  }, [language]);

  return { t };
}